<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "Audittransactions"
};
</script>

<style></style>
